import { Stack, Typography } from "@mui/material";
import { t } from "i18next";
import Template from "../../../components/Dashboard/Template";
import SupplierBarChart from "./SupplierBarChart";

function MonthlyReport({ monthlyReport, isLoading }) {
  return (
    <Template
      primaryHeading={t("monthlyReport")}
      secondaryHeading={t("hitList")}
    >
      {monthlyReport?.length > 0 ? (
        <SupplierBarChart chartData={monthlyReport} />
      ) : isLoading === false && monthlyReport?.length === 0 ? (
        <Stack height={"100%"} alignItems={"center"} justifyContent={"center"}>
          <Typography variant="h5" fontWeight={600}>
            {t("noDataFound")}!
          </Typography>
        </Stack>
      ) : null}
    </Template>
  );
}

export default MonthlyReport;
